import { render, staticRenderFns } from "./salesServicePricingEditor.vue?vue&type=template&id=325b54c6&"
import script from "./salesServicePricingEditor.vue?vue&type=script&lang=js&"
export * from "./salesServicePricingEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports